if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) {
var script_loaded=!1;
function loadJSscripts(){if(!script_loaded){script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);document.dispatchEvent(new CustomEvent("StartKernelLoading")),setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading"))},40)}}
loadJSscripts();
window.addEventListener("scroll",function(t){loadJSscripts()}),window.addEventListener("mousemove",function(){loadJSscripts()}),window.addEventListener("touchstart",function(){loadJSscripts()}),window.addEventListener?window.addEventListener("load",function(){setTimeout(loadJSscripts,10)},!1):window.attachEvent?window.attachEvent("onload",function(){setTimeout(loadJSscripts,10)}):window.onload=loadJSscripts;
}



jQuery(document).ready(function (){
    jQuery('.c_cart-qty-slct').each(function (index) {
      jQuery(this).change(function () {
          var variantId = jQuery(this).find('option:selected').attr('data-variantId');
          var qtyVal = jQuery(this).find('option:selected').val()
          // console.log(qtyVal,variantId)
          var requestData = {
            quantity: qtyVal,
            id: variantId
          };
          jQuery.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json', // Assuming the response is in JSON format
            data: requestData,
            success: function(response) {
              // Handle the successful API response here
              // console.log('API response:', response);
              // var parseJson = JSON.parse(response)
              
                jQuery(response.items).each(function (index, item) {
                    if (item.id == parseInt(variantId)) {
                        jQuery('.cart__row[data-cartitem-id="'+variantId+'"] [data-cart-item-regular-price]').html(Shopify.formatMoney(item.final_line_price))
                    }
                });
              jQuery('[data-cart-subtotal] p').html(Shopify.formatMoney(response.original_total_price))
              jQuery('[data-cart-count]').text(response.item_count)
            },
            error: function(xhr, status, error) {
              // Handle any errors that occur during the API call
              console.error('Error:', error);
            }
          });
          // changeAPiCall(variantId, qtyVal)
      });
    });

  // jQuery('.product-single__thumbnails').on('mouseover', '.slick-slide', function (e) {
  //     var $currTarget = jQuery(e.currentTarget), 
  //     index = $currTarget.data('slick-index'),
  //     slickObj = jQuery('.product-single__media-group').slick('getSlick');
      
  //     slickObj.slickGoTo(index);
  // });
  
});
